import React, { useContext, useEffect, useState, useCallback } from "react";
import { useSnackbar } from "../Utility/UserMessageContext";
import {
  Box,
  Button,
  Card,
  Grid2,
  IconButton,
  TableCell,
  TableContainer,
  TableRow,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import AuthContext from "../Context/AuthProvider";
import { Fragment } from "react";
import {
  Paper,
  Select,
  Table,
  TableBody,
  TableHead,
  TextField,
} from "@mui/material";
import { getFacilityUsers } from "../API/UsersApi";
import { getClinicalServices } from "../API/FacilitySettingsApi";
import SearchSelectPatient1 from "../Patients/SearchSelectPatient1";
import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import MenuBar from "../common/MenuBar";
import "../common/styles/CommonStyles.css"; // Import your custom styles
import GenericTextField from "../common/GenericTextField";
import HeaderValueDisplay from "../common/HeaderValueDisplay";
import GenericDatePicker from "../common/GenericDatePicker";
import GenericDropDown from "../common/GenericDropDown";
import CloseIcon from "@mui/icons-material/Close";
import GenericActionButton from "../common/GenericActionButton";
import { Add } from "@mui/icons-material";
import { getDisplayValue, showLoadingImage } from "../Utility/Utility";
import { getPlanById, updatePlan } from "../API/PlansApi";
import { useEffectEvent } from "react";

const EditPlan = ({
  key,
  planId,
  plan,
  onViewPatientDetails,
  onViewVisitDetails,
  onEditBill,
  closeTab,
}) => {
  const { auth } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const { showSnackbar } = useSnackbar();
  const [planData, setplanData] = useState({
    visits: [],
  });
  const [totalBilledAmount, settotalBilledAmount] = useState(0);
  const [totalAmount, settotalAmount] = useState(0);
  const [availableServices, setAvailableServices] = useState();
  const [availablePhysicians, setAvailablePhysicians] = useState();
  const [firstVisit, setfirstVisit] = useState();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const [originalVisits, setoriginalVisits] = useState([]);
  const [removedVisitIds, setremovedVisitIds] = useState([]);

  useEffect(() => {
    if (planData && planData?.visits?.length > 0) {
      const total = planData?.visits?.reduce((acc, curr) => {
        let billAmount =
          curr?.primaryServiceFees *
          (1 - curr?.primaryServiceDiscountInPercentage / 100);
        return acc + (Number(billAmount) || 0);
      }, 0);
      settotalBilledAmount(total);
    }
    if (planData && planData?.visits?.length > 0) {
      let totalAmount = 0;
      planData?.visits?.map((visit) => {
        totalAmount = visit?.primaryServiceFees + totalAmount;
      });
      settotalAmount(totalAmount);
    }
    console.log("plandata", plan);
  }, [planData]);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);

      try {
        const result = await getPlanById(auth, planId);
        if (result.isSuccess) {
          setplanData(result.data);
          setfirstVisit(result.data.visits?.[0]);
          setoriginalVisits(result?.data?.visits);
          // const billResult = await getBillByPlanId(auth, planId);
          // if (billResult.isSuccess) {
          //   setBillDetails(billResult.data);
          // }
          const filters = {
            facilityId: auth.selectedFacility.id,
            visitType: result.data?.currentVisitType || "OPD",
          };
          const response = await getClinicalServices(auth, filters);
          if (response.isSuccess) {
            setAvailableServices(response?.data);
          }
          const responseData = await getFacilityUsers(auth, {
            facilityId: auth.selectedFacility.id,
            roles: ["Physician"],
          });
          if (responseData?.isSuccess) {
            setAvailablePhysicians(responseData?.data);
          }
        }
      } catch (error) {
        console.error("Error loading plans:", error);
        showSnackbar(
          "An unexpected error occurred while loading plans.",
          "error",
        );
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [planId]);

  const getEndDateTime = (startDateTime, durationInMinutes) => {
    if (!startDateTime || typeof durationInMinutes !== "number") {
      return startDateTime;
    }

    const start = dayjs(startDateTime);

    if (!start.isValid()) return null;

    let end = start.add(durationInMinutes, "minute");
    return end.toISOString();
  };

  const addPlan = async () => {
    setIsLoading(true);

    let updatedVisits = [];
    let tempNewVisits = [];

    const originalVisitIdSet = new Set(originalVisits.map((v) => v.id));

    planData?.visits?.forEach((visit) => {
      if (!visit.id) {
        tempNewVisits.push(visit); // New visit (no ID )
      } else if (originalVisitIdSet.has(visit.id)) {
        updatedVisits.push({ ...visit });
      }
    });

    updatedVisits = updatedVisits.map((visit) => ({
      id: visit.id,
      scheduledStartDateTime: visit.scheduledStartDateTime,
      scheduledEndDateTime: getEndDateTime(
        visit.scheduledStartDateTime,
        visit.primaryServiceDurationInMins,
      ),
      physicianId: visit.physicianId,
      notes: visit.clinicalSummary,
      clinicalServiceId: visit.primaryClinicalServiceId,
      onwardTravelTimeInMins: 0,
      returnTravelTimeInMins: 0,
      referredBy: visit.referredBy,
      discountInPercentage: visit.primaryServiceDiscountInPercentage,
    }));

    const newVisits = tempNewVisits.map((visit) => ({
      patientId: visit.patientId,
      physicianId: visit.physicianId,
      scheduledStartDateTime: visit.scheduledStartDateTime,
      scheduledEndDateTime: getEndDateTime(
        visit.scheduledStartDateTime,
        visit.primaryServiceDurationInMins,
      ),
      onwardTravelTimeInMins: 0,
      returnTravelTimeInMins: 0,
      notes: visit.notes,
      clinicalServiceId: visit.primaryClinicalServiceId,
      facilityId: visit.facilityId,
      visitType: visit.currentVisitType,
      referredBy: visit.referredBy,
      discountInPercentage: visit.primaryServiceDiscountInPercentage,
      advanceAmount: visit.advanceAmount,
      paymentMode: visit.paymentMode,
      planId: visit.planId,
    }));

    const result = await updatePlan(auth, {
      id: planData?.id,
      name: planData?.name,
      billingSummary: planData?.billingSummary,
      clinicalSummary: planData?.clinicalSummary,
      paidAmount: planData?.paidAmount,
      paymentMode: planData?.paymentMode,
      paymentNotes: planData?.paymentNotes,
      physicianId: planData?.physicianId,
      updatedVisits,
      removedVisitIds,
      newVisits,
    });
    if (result.isSuccess) {
      showSnackbar("Plan Edited successfully.", "success");
      closeTab(key);
    } else {
      showSnackbar(result.data, "error");
    }
    console.log("payload data", planData);

    setIsLoading(false);
  };

  const handleChange = (e) => {
    setplanData({
      ...planData,
      [e.target.name]: e.target.value,
    });
  };

  const generateSessions = () => {
    const copied = [...planData.visits];

    copied.push({
      planId: planData?.id,
      patientId: planData?.patientId,
      physicianId: null,
      scheduledStartDateTime: null,
      scheduledEndDateTime: null,
      primaryClinicalServiceId: null,
      facilityId: auth.selectedFacility.id,
      currentVisitType: planData?.visits?.[0]?.currentVisitType || "OPD",
      primaryServiceDiscountInPercentage: 0,
      schedulingNotes: planData?.schedulingNotes,
      referredBy: planData?.referredBy,
      primaryServiceName: "",
      primaryServiceDiscountInPercentage: 0,
      primaryServiceDurationInMins: null,
      primaryServiceFees: null,
      notes: planData?.schedulingNotes,
      advanceAmount: planData?.paidAmount,
      paymentMode: planData?.paymentMode,
    });
    setplanData({ ...planData, visits: copied });
  };

  return (
    <>
      <Grid2 container>
        <Grid2 container size={12}>
          {/* Save Plan Action */}
          <Grid2
            container
            size={12}
            sx={{ justifyContent: "start", alignItems: "center" }}
          >
            <Grid2 size={12}>
              {isLoading && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(216, 214, 214, 0.4)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1301,
                  }}
                >
                  {showLoadingImage()}
                </div>
              )}

              <MenuBar
                showSave={true}
                onSave={() => addPlan()}
                saveLabel="Save Plan"
                saveTooltip="Save Plan"
                disabled={isLoading}
              />
            </Grid2>
          </Grid2>
        </Grid2>
        <Grid2
          size={12}
          container
          spacing={2}
          sx={{
            paddingX: 2,
            maxHeight: "calc(100vh - 150px)",
            overflowY: "auto",
          }}
        >
          <Card className="outerCard" variant="outlined">
            <Grid2 size={12} container spacing={1} sx={{ padding: 1 }}>
              <Grid2
                size={6}
                container
                spacing={1}
                sx={{
                  padding: 1,
                  border: "2px solid rgb(215, 217, 220)",
                  borderRadius: 2,
                }}
              >
                <Grid2 container size={12} spacing={1} alignItems="start">
                  {/* Plan Name Input */}
                  <Grid2 size={{ xs: 12, md: 12 }}>
                    <GenericTextField
                      label="Plan Name"
                      value={planData?.name || ""}
                      onChange={handleChange}
                      disabled={isLoading}
                      inputSlotProps={{
                        inputLabel: { shrink: Number(planData.name) > 0 },
                      }}
                      name="name"
                      fullWidth
                      size="small"
                      placeholder="Enter Plan Name"
                      helperText=""
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 12 }} item>
                    <GenericTextField
                      label="Patient Name"
                      value={
                        planData?.patientFirstName +
                          " " +
                          planData?.patientLastName || ""
                      }
                      disabled
                      fullWidth
                      size="small"
                      helperText=""
                    />
                  </Grid2>
                </Grid2>

                <Grid2 container size={12} spacing={1} alignItems="start">
                  <Grid2 container size={{ xs: 12, md: 12 }}>
                    <GenericDropDown
                      label="Physician"
                      value={planData?.physicianId || ""}
                      options={
                        availablePhysicians?.map((p) => ({
                          value: p.id,
                          label: `${p.salutation} ${p.firstName} ${p.lastName}, ${p.suffix}`,
                        })) || []
                      }
                      name="physician"
                      size="small"
                      disabled
                    />
                  </Grid2>
                </Grid2>

                <Grid2 container size={12} spacing={1} alignItems="start">
                  <Grid2 size={{ xs: 12, md: 12 }}>
                    <GenericDropDown
                      label="Visit Type"
                      value={planData?.visits?.[0]?.currentVisitType || ""}
                      options={[
                        { value: "Home", label: "Home" },
                        { value: "OPD", label: "OPD" },
                      ]}
                      disabled
                      size="small"
                    />
                  </Grid2>
                </Grid2>
              </Grid2>

              <Grid2
                size={6}
                container
                spacing={1}
                sx={{
                  padding: 1,
                  border: "2px solid rgb(215, 217, 220)",
                  borderRadius: 2,
                }}
              >
                <Grid2 container size={12} spacing={1} alignItems={"start"}>
                  <Grid2 container size={{ xs: 12, md: 12 }}>
                    <GenericTextField
                      label="Patient Summary"
                      value={planData.clinicalSummary || ""}
                      multiline
                      minRows={4}
                      maxRows={5}
                      disabled={isLoading}
                      size="small"
                      name="clinicalSummary"
                      onChange={handleChange}
                      inputSlotProps={{
                        inputLabel: {
                          shrink: Number(planData?.clinicalSummary) > 0,
                        },
                      }}
                      helperText=""
                    />
                  </Grid2>
                  <Grid2 container size={{ xs: 12, md: 12 }}>
                    <GenericTextField
                      label="Bill Summary"
                      value={planData.billingSummary || ""}
                      name="billingSummary"
                      multiline
                      minRows={4}
                      maxRows={5}
                      disabled={isLoading}
                      size="small"
                      onChange={handleChange}
                      inputSlotProps={{
                        inputLabel: {
                          shrink: Number(planData?.billingSummary) > 0,
                        },
                      }}
                      helperText=""
                    />
                  </Grid2>
                </Grid2>
              </Grid2>
            </Grid2>

            <Grid2
              size={12}
              container
              spacing={2}
              sx={{
                padding: 2,
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
              }}
            >
              <Tooltip title="Add Visits" arrow>
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  onClick={generateSessions}
                  disabled={isLoading}
                  sx={{ textTransform: "none" }}
                  startIcon={<Add />}
                >
                  Add Visits
                </Button>
              </Tooltip>
            </Grid2>

            <Grid2
              container
              size={12}
              spacing={1}
              sx={{
                padding: 1,
                border: "2px solid rgb(215, 217, 220)",
                borderRadius: 2,
              }}
            >
              <TableContainer
                component={Paper}
                sx={{
                  maxHeight: 300,
                  overflowY: "auto",
                }}
                className="outerCard"
              >
                <Table sx={{ minWidth: 650 }} size="small" stickyHeader>
                  <TableHead>
                    <TableRow
                      sx={{
                        background:
                          "linear-gradient(90deg, #e3f2fd 0%, #f5f7fa 100%)",
                      }}
                    >
                      <TableCell
                        align="center"
                        sx={{ fontWeight: "bold", width: "5%" }}
                      >
                        #
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold", width: "15%" }}>
                        Date
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold", width: "15%" }}>
                        Time
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold", width: "20%" }}>
                        Visit Status
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold", width: "10%" }}>
                        Duration
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold", width: "15%" }}>
                        Primary Service
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold", width: "15%" }}>
                        Assigned To
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold", width: "10%" }}>
                        Discount
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold", width: "10%" }}>
                        Bill Amount
                      </TableCell>

                      <TableCell
                        align="center"
                        sx={{ fontWeight: "bold", width: "5%" }}
                      ></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {planData &&
                      planData?.visits?.map((visit, index) => {
                        const isReadOnly =
                          visit?.visitStatus === "InProgress" ||
                          visit?.visitStatus === "Completed";
                        return (
                          <TableRow key={index} hover>
                            <TableCell align="center" width={"10px"}>
                              {index + 1}
                            </TableCell>
                            <TableCell>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <GenericDatePicker
                                  label="Select Date"
                                  value={
                                    visit?.scheduledStartDateTime
                                      ? dayjs(visit.scheduledStartDateTime)
                                      : null
                                  }
                                  disabled={isReadOnly}
                                  minDate={dayjs()}
                                  onChange={(newDate) => {
                                    if (!newDate) return;
                                    newDate = dayjs(newDate);
                                    const copied = [...planData.visits];
                                    const idx =
                                      visit?.id != null
                                        ? copied.findIndex(
                                            (v) => v.id === visit.id,
                                          )
                                        : index; // fallback for new visit

                                    if (idx === -1) return;

                                    const existing = copied[idx]
                                      ?.scheduledStartDateTime
                                      ? dayjs(
                                          copied[idx].scheduledStartDateTime,
                                        )
                                      : dayjs();

                                    const merged = existing
                                      .year(newDate?.year())
                                      .month(newDate?.month())
                                      .date(newDate?.date());

                                    copied[idx].scheduledStartDateTime =
                                      merged.toISOString();

                                    setplanData({
                                      ...planData,
                                      visits: copied,
                                    });
                                  }}
                                  sx={{ width: "160px" }}
                                />
                              </LocalizationProvider>
                            </TableCell>
                            <TableCell>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <TimePicker
                                  label="Select Time"
                                  value={
                                    visit?.scheduledStartDateTime
                                      ? dayjs(visit.scheduledStartDateTime)
                                      : null
                                  }
                                  disabled={isReadOnly}
                                  onChange={(newTime) => {
                                    if (!newTime) return;

                                    const copied = [...planData.visits];
                                    const idx =
                                      visit?.id != null
                                        ? copied.findIndex(
                                            (v) => v.id === visit.id,
                                          )
                                        : index; // fallback for new visit

                                    if (idx === -1) return;

                                    const existing = copied[idx]
                                      ?.scheduledStartDateTime
                                      ? dayjs(
                                          copied[idx].scheduledStartDateTime,
                                        )
                                      : dayjs();

                                    const merged = existing
                                      .hour(newTime.hour())
                                      .minute(newTime.minute())
                                      .second(newTime.second());

                                    copied[idx].scheduledStartDateTime =
                                      merged.toISOString();

                                    setplanData({
                                      ...planData,
                                      visits: copied,
                                    });
                                  }}
                                  sx={{
                                    background: "#fff",
                                    borderRadius: 1,
                                  }}
                                  slotProps={{ textField: { size: "small" } }}
                                ></TimePicker>
                              </LocalizationProvider>
                            </TableCell>

                            <TableCell>
                              {/* duration (Free Text) */}
                              <TextField
                                variant="outlined"
                                size="small"
                                fullWidth
                                value={visit?.visitStatus || ""}
                                placeholder="Visit Status"
                                sx={{
                                  background: "#fff",
                                  borderRadius: 1,
                                }}
                                disabled={isReadOnly}
                              />
                            </TableCell>

                            <TableCell>
                              {/* duration (Free Text) */}
                              <TextField
                                variant="outlined"
                                size="small"
                                fullWidth
                                type="number"
                                value={
                                  visit?.primaryServiceDurationInMins || ""
                                }
                                disabled={isReadOnly}
                                onChange={(e) => {
                                  const copied = [...planData.visits];

                                  const idx =
                                    visit?.id != null
                                      ? copied.findIndex(
                                          (v) => v.id === visit.id,
                                        )
                                      : index; // fallback for new visit

                                  if (idx === -1) return;

                                  copied[idx].primaryServiceDurationInMins =
                                    e.target.value;
                                  setplanData({ ...planData, visits: copied });
                                }}
                                placeholder="Duration in Min"
                                sx={{
                                  background: "#fff",
                                  borderRadius: 1,
                                }}
                              />
                            </TableCell>

                            <TableCell
                              sx={{
                                width: 180,
                                maxWidth: 180,
                                whiteSpace: "nowrap",
                              }}
                            >
                              <GenericDropDown
                                value={
                                  visit?.primaryClinicalServiceId
                                    ? visit?.primaryClinicalServiceId
                                    : null
                                }
                                disabled={isReadOnly}
                                onChange={(e) => {
                                  const selectedServiceId = e.target.value;
                                  const selectedService =
                                    availableServices.find(
                                      (s) => s.id === selectedServiceId,
                                    );
                                  const copied = [...planData.visits];

                                  const idx =
                                    visit?.id != null
                                      ? copied.findIndex(
                                          (v) => v.id === visit.id,
                                        )
                                      : index; // fallback for new visit

                                  if (idx === -1) return;

                                  copied[idx].primaryClinicalServiceId =
                                    selectedServiceId;
                                  copied[idx].primaryServiceDurationInMins =
                                    selectedService.durationInMins;
                                  copied[idx].primaryServiceFees =
                                    selectedService.fees;
                                  copied[idx].primaryServiceName =
                                    selectedService.name;
                                  setplanData({ ...planData, visits: copied });
                                }}
                                options={
                                  availableServices?.map((s) => ({
                                    value: s.id,
                                    label: `${s.name}, Fees Rs. ${s.fees}, Duration ${s.durationInMins} Mins`,
                                  })) || []
                                }
                                name="service"
                                size="small"
                                
                              />
                            </TableCell>
                            <TableCell>
                              <GenericDropDown
                                value={visit?.physicianId || ""}  
                                disabled={isReadOnly || isLoading}                           
                                onChange={(e) => {
                                  const selectedPhysician =
                                    availablePhysicians.find(
                                      (s) => s.id === e.target.value,
                                    );
                                  const copied = [...planData.visits];
                                  const idx =
                                    visit?.id != null
                                      ? copied.findIndex(
                                          (v) => v.id === visit.id,
                                        )
                                      : index; // fallback for new visit

                                  if (idx === -1) return;
                                  copied[idx].physicianId = e.target.value;

                                  setplanData({
                                    ...planData,
                                    visits: copied,
                                  });
                                }}
                                options={
                                  availablePhysicians?.map((p) => ({
                                    value: p.id,
                                    label: `${p.salutation} ${p.firstName} ${p.lastName}, ${p.suffix}`,
                                  })) || []
                                }
                                name="assignedTo"
                                size="small"
                                
                                fullWidth
                                sx={{ width: "175px" }}
                              />
                            </TableCell>
                            {/* discount */}
                            <TableCell>
                              {/* discount (Free Text) */}
                              <TextField
                                variant="outlined"
                                size="small"
                                fullWidth
                                type="number"
                                inputProps={{ min: 0, max: 100 }}
                                disabled={isReadOnly}
                                value={
                                  visit.primaryServiceDiscountInPercentage || ""
                                }
                                onChange={(e) => {
                                  const copied = [...planData.visits];
                                  const idx =
                                    visit?.id != null
                                      ? copied.findIndex(
                                          (v) => v.id === visit.id,
                                        )
                                      : index; // fallback for new visit

                                  if (idx === -1) return;
                                  copied[
                                    idx
                                  ].primaryServiceDiscountInPercentage =
                                    e.target.value;
                                  copied[idx].billAmount =
                                    copied[idx].primaryServiceFees *
                                    (1 - e.target.value / 100);

                                  setplanData({ ...planData, visits: copied });
                                }}
                                placeholder="discount in %"
                                sx={{
                                  background: "#fff",
                                  borderRadius: 1,
                                }}
                              />
                            </TableCell>
                            {/* Amount */}
                            <TableCell>
                              {/* billAmount (Free Text) */}
                              <TextField
                                variant="outlined"
                                size="small"
                                fullWidth
                                type="number"
                                value={
                                  visit?.primaryServiceFees *
                                  (1 -
                                    visit?.primaryServiceDiscountInPercentage /
                                      100)
                                }
                                placeholder="Bill Amount"
                                sx={{
                                  background: "#fff",
                                  borderRadius: 1,
                                }}
                                disabled={isReadOnly}
                              />
                            </TableCell>

                            <TableCell>
                              <IconButton
                                color="error"
                                size="small"
                                onClick={() => {
                                  const copied = [...planData.visits];
                                  if (visit?.id != null) {
                                    setremovedVisitIds((prev) => [
                                      ...prev,
                                      visit.id,
                                    ]);
                                  }
                                  const updated =
                                    visit?.id != null
                                      ? copied.filter((v) => v.id !== visit.id) // existing visit
                                      : copied.filter((_, i) => i !== index); // new visit (no id)

                                  setplanData({ ...planData, visits: updated });
                                }}
                                disabled={isReadOnly}
                              >
                                <CloseIcon fontSize="small" />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>

              <Grid2
                size={12}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  justifyContent: "end",
                  marginTop: "10px",
                }}
              >
                <Typography fontSize="18px" color="primary">
                  Total Amount
                </Typography>
                <Typography fontSize="18px" variant="body1">
                  {planData?.visits?.length === 0 ? 0 : totalAmount}
                </Typography>
                <Typography fontSize="18px" color="primary">
                  Total Discount
                </Typography>
                <Typography fontSize="18px" variant="body1">
                  {(totalAmount - totalBilledAmount).toFixed(2)} (
                  {totalBilledAmount
                    ? (
                        ((totalAmount - totalBilledAmount) * 100) /
                        totalAmount
                      ).toFixed(2)
                    : 0}{" "}
                  in % )
                </Typography>
                <Typography fontSize="18px" color="primary">
                  Total Billed Amount
                </Typography>
                <Typography fontSize="18px" variant="body1">
                  {planData?.visits?.length === 0 ? 0 : totalBilledAmount}
                </Typography>
              </Grid2>
            </Grid2>
          </Card>
        </Grid2>
      </Grid2>
    </>
  );
};

export default EditPlan;
